// German — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const de = {
  "uploadTitle": "Fotos hochladen",
  "uploadHint": "Bilder hierher ziehen oder klicken",
  "uploadHintTouch": "Zum Auswählen tippen",
  "uploadOr": "oder",
  "takePhoto": "Foto aufnehmen",
  "yourPhotos": "Deine Fotos",
  "photoLabel": "Foto {n}",
  "photoCount": "{n} Fotos",
  "addPhoto": "Foto hinzufügen",
  "continue": "Weiter",
  "stepLabel": "Schritt {current} von {total}",
  "chooseStyle": "Designstil wählen",
  "describeCustomStyle": "Beschreibe deinen eigenen Stil",
  "uploadReferenceTitle": "Referenzfoto hochladen",
  "uploadReferenceHint": "Die KI übernimmt Farbtöne, Materialien und Stimmung – dein Raumbild bleibt unverändert.",
  "removeReference": "Referenz entfernen",
  "cleanupOptionTidy": "Aufräumen",
  "cleanupOptionTidyDesc": "Möbel behalten, Unordnung/Müll/Geschirr entfernen",
  "cleanupOptionEmpty": "Raum leeren",
  "cleanupOptionEmptyDesc": "Alle Möbel und Deko entfernen. Wände und Boden bleiben",
  "cleanupChooseOption": "Aufräum-Methode wählen",
  "layoutOptionFlow": "Bessere Laufwege",
  "layoutOptionFlowDesc": "Laufwege und Zugang verbessern – für mehr Bewegungsfreiheit",
  "layoutOptionSpacious": "Geräumiger",
  "layoutOptionSpaciousDesc": "Sichtachsen öffnen und Unordnung reduzieren – wirkt größer",
  "planChooseOption": "Was sollen wir aus deinem Grundriss machen?",
  "planOption_3d": "3D-Grundriss",
  "planOption_3dDesc": "Das ganze Zuhause von oben, im gewählten Stil eingerichtet",
  "planOption_room": "Ein Raum",
  "planOption_roomDesc": "Markiere einen Raum auf dem Plan und sieh ihn auf Augenhöhe",
  "planOption_clean": "Grundriss neu zeichnen",
  "planOption_cleanDesc": "Eine Skizze oder unscharfer Plan, sauber neu gezeichnet",
  "planCleanKindTitle": "Zeichnungsart",
  "planCleanKind_line": "Schwarz-Weiß",
  "planCleanKind_color": "Farbiger Grundriss",
  "planStyleTitle": "Stil",
  "planRoomTitle": "Welcher Raum?",
  "planRoomSignIn": "Melde dich an, um einen Raum auf deinem Plan auszuwählen.",
  "planRoomPaint": "Raum auf dem Plan markieren",
  "planRoomPicked": "Raum ausgewählt",
  "planRoomRepaint": "Erneut markieren",
  "planRoomClear": "Löschen",
  "planRoomNamePlaceholder": "Oder tippe den Raumnamen ein (z. B. Schlafzimmer)",
  "planCropHint": "Schneide das Foto auf den Grundriss zu, um ein genaueres Ergebnis zu erhalten.",
  "planFirstOnly": "Nur das erste Foto wird als Grundriss verwendet.",
  "planRoomPickTitle": "Raum auswählen",
  "planRoomPickHint": "Markiere den Raum, den du sehen möchtest. Grob ausfüllen reicht.",
  "planRoomPickDone": "Diesen Raum nutzen",
  "planRoomNeedPick": "Markiere einen Raum auf dem Plan oder gib seinen Namen ein.",
  "errNotFloorplan": "Das sieht nicht nach einem Grundriss aus. Lade einen Grundriss hoch oder wähle stattdessen einen Stil.",
  "planRoomFrom": "Auf dem Plan ausgewählter Raum",
  "planInputLabel": "Grundriss",
  "planOutput_plan_3d": "3D-Grundriss",
  "planOutput_plan_room": "Raumansicht",
  "planOutput_plan_clean": "Sauberer Grundriss",
  "planOutput_plan_color": "Farbiger Grundriss",
  "planRoomFromResult": "Einen Raum ansehen",
  "planRoomMake": "Diesen Raum erstellen",
  "planRoomMeta": "{n} Credits · dieser Raum auf Augenhöhe, selbes Zuhause",
  "layoutChooseOption": "Umstellungs-Methode wählen",
  "creditEarnHint": "Verdiene Credits durch tägliches Anmelden (+1) oder Freunde einladen (+5).",
  "languageHint": "Wird auch für die Design-Analyse verwendet.",
  "reuseStyle": "— Früheren Stil wiederverwenden —",
  "customPlaceholder": "Beschreibe deinen Wunschstil (z. B. „gemütliche Hütte mit warmen Holztönen“, „futuristischer Minimalismus mit Metallakzenten“)",
  "customStylePublicHint": "Dein Stil-Text kann anonym in der Community erscheinen. Du kannst dies in den Kontoeinstellungen deaktivieren.",
  "communityRankTitle": "Trend-Stile",
  "communityPeople": "Von {n} Personen genutzt",
  "customStylesChip": "Eigene Stile",
  "galleryRecentBadge": "Gerade genutzt",
  "timeJustNow": "gerade eben",
  "timeAgoMin": "vor {n} Min.",
  "timeAgoHour": "vor {n} Std.",
  "communityViewAll": "Alle anzeigen",
  "galleryTitle": "Trend-Stile",
  "briefsLabel": "Neues",
  "briefTopupKicker": "Guthaben",
  "briefTopupTitle": "Nicht genug Guthaben für das nächste Design",
  "briefTopupLine": "Gratis-Credits laden morgen nach. Brauchst du jetzt mehr? Hol dir ein Paket.",
  "briefSeasonKicker": "Saisonal",
  "briefSeasonTitle": "{name} ist da",
  "briefSeasonLine": "Ein saisonaler Stil – nur für wenige Wochen.",
  "briefInviteKicker": "Einladen",
  "briefInviteTitle": "Lade Freunde ein – ihr bekommt beide +{n} Credits",
  "briefInviteLine": "Teile deinen Link. Die Credits kommen nach der Registrierung.",
  "galleryEmpty": "Noch keine Trends — Stile erscheinen hier, sobald sie genutzt werden.",
  "galleryBuiltinTitle": "Aktuelles Stil-Ranking",
  "galleryPopularCustom": "Aktuell beliebte eigene Stile",
  "galleryDiscoverTitle": "Eigene Stile entdecken",
  "galleryShuffle": "Mischen",
  "galleryTranslate": "Übersetzen",
  "galleryTranslating": "Übersetze…",
  "galleryOriginal": "Original anzeigen",
  "galleryLiveTab": "Live",
  "galleryLiveWaiting": "Warte auf neue Stile…",
  "galleryLiveTitle": "Gerade in Verwendung",
  "galleryRecentCustom": "Neueste eigene Stile",
  "galleryUse": "Stil verwenden",
  "styleShareNotice": "Dein Stil-Text kann anonym in der Community erscheinen.",
  "styleShareNoticeSettings": "In Einstellungen deaktivieren",
  "styleShareNoticeOk": "Verstanden",
  "communityTopTitle": "Beliebte eigene Stile",
  "communityRecentTitle": "Gerade von anderen genutzt",
  "communityUses": "{n}× genutzt",
  "communityDesigns": "{n} Designs",
  "communityDesignsOne": "{n} Design",
  "styleShareTitle": "Eigene Stile teilen",
  "styleShareDesc": "Lass andere deine Stil-Texte entdecken und ausprobieren. Deine Fotos werden niemals geteilt.",
  "additionalRequests": "Zusätzliche Wünsche",
  "optional": "(optional)",
  "additionalPlaceholder": "Gibt es Ergänzungen für dein {style}-Design? (z. B. 'Holz-Couchtisch hinzufügen', 'Blaugrün als Akzentfarbe')",
  "addAdditionalRequest": "+ Spezifische Wünsche hinzufügen",
  "generateDesign": "Design generieren",
  "back": "Zurück",
  "generatingOne": "KI generiert dein Innendesign…",
  "generatingMany": "KI generiert {n} konsistente Designs für deinen Raum…",
  "generatingOneExterior": "KI generiert dein Außendesign…",
  "generatingManyExterior": "KI generiert {n} konsistente Außen-Renderings…",
  "generatingOneGarden": "KI generiert deine Garten-Neugestaltung…",
  "generatingManyGarden": "KI generiert {n} konsistente Garten-Renderings…",
  "generationFailed": "Generierung fehlgeschlagen",
  "tryAgain": "Erneut versuchen",
  "errNoInternet": "Keine Internetverbindung. Bitte überprüfe dein Netzwerk und versuche es erneut.",
  "errTimeout": "Die KI hat zu lange für eine Antwort gebraucht. Bitte versuche es erneut.",
  "errTooMany": "Zu viele Anfragen. Bitte warte einen Moment und versuche es erneut.",
  "errNetwork": "Netzwerkfehler. Bitte überprüfe deine Verbindung und versuche es erneut.",
  "errAI": "Beim KI-Design-Service ist ein Fehler aufgetreten. Bitte versuche es erneut.",
  "errFileType": "Nicht unterstütztes Dateiformat. Bitte lade ein JPEG-, PNG- oder WebP-Bild hoch.",
  "errFileTooLarge": "Datei ist zu groß. Bitte lade ein Bild unter 20 MB hoch.",
  "errPhotoRead": "Foto konnte nicht gelesen werden. Bitte versuche ein anderes.",
  "errCameraAccess": "Kein Zugriff auf Kamera. Bitte erlaube den Zugriff in den Einstellungen.",
  "errCameraCapture": "Foto konnte nicht aufgenommen werden. Bitte versuche es erneut.",
  "errCaptionSave": "Beschriftung konnte nicht gespeichert werden. Bitte versuche es erneut.",
  "imageUnavailable": "Bild nicht verfügbar",
  "designShareText": "Schau dir dieses {style}-Design an, erstellt mit archelier",
  "altPhoto": "Foto {n}",
  "altOriginal": "Original {n}",
  "altGenerated": "Design {n}",
  "errInvalidSpace": "Wir konnten dies nicht als Raum erkennen. Nutze ein Foto, das einen Raum zeigt – Wand und Boden zusammen oder eine Zimmerecke.",
  "pickAnotherPhoto": "Anderes Foto wählen",
  "errCustomStyle": "Bitte beschreibe deinen eigenen Stil.",
  "errSignIn": "Anmeldung fehlgeschlagen. Bitte versuche es erneut.",
  "errInsufficientCredits": "Keine Credits mehr übrig. Komm morgen für deinen täglichen Bonus wieder.",
  "creditCostHint": "{n} Fotos verbrauchen {c} Credits — {p} pro Foto.",
  "errCreditsShort": "Dafür brauchst du {need} Credits, du hast {have}. Entferne ein Foto oder lade Freunde ein.",
  "credits": "Credits",
  "creditsOne": "{n} Credit",
  "creditsMany": "{n} Credits",
  "outOfCredits": "Keine Credits mehr",
  "creditModalTitle": "Mehr Credits holen",
  "creditModalDesc": "Deine täglichen Credits laden sich morgen auf. Möchtest du jetzt schon mehr?",
  "creditModalWallDesc": "Das waren deine Gratis-Designs für heute. Morgen gibt es {n} neue — oder lade jetzt auf und mach weiter.",
  "errOutOfCreditsToday": "Deine Credits für heute sind aufgebraucht. Morgen gibt es {n} gratis Designs — oder lade auf und mach weiter.",
  "lastFreeHint": "Das war das letzte gratis Design für heute. Morgen gibt's {n} neue.",
  "lastFreeHintCta": "Jetzt aufladen",
  "creditModalChatFree": "Der Chat mit Gio, deinem Designer, bleibt kostenlos.",
  "creditModalGuestTitle": "Anmelden, um weiterzugestalten",
  "creditModalGuestDesc": "Durch die Anmeldung erhältst du täglich kostenlose Credits, kannst speichern und teilen.",
  "creditOptionSignIn": "Anmelden und fortfahren",
  "creditOptionSignInDesc": "In einer Sekunde starten mit Google oder Apple",
  "creditOptionInvite": "Freunde einladen",
  "creditOptionInviteDesc": "Ihr erhaltet beide +{n} Credits bei Registrierung",
  "comingSoon": "Demnächst verfügbar",
  "close": "Schließen",
  "getAppTitle": "archelier",
  "getAppDesc": "Gestalte deinen Raum in der App",
  "getAppCta": "Holen",
  "appGateTitle": "In der App weitermachen",
  "appGateDesc": "Gestalten geht in der App besser — Kamera, gespeicherte Designs und schnellere Ergebnisse.",
  "appGateCta": "App holen",
  "appGateNotNow": "Später",
  "dailyBonusHint": "Du erhältst jeden Tag {n} kostenlose Credits.",
  "creditsAria": "{n} Credits übrig",
  "accountCreditsTitle": "Credits",
  "creditsDailyLabel": "Täglich, setzt sich um Mitternacht zurück",
  "creditsBonusLabel": "Bonus, verfällt nie",
  "creditsResetHint": "Du erhältst jeden Tag {n} kostenlose Credits. Bonus-Credits durch Einladungen bleiben bestehen, bis du sie nutzt.",
  "creditsInviteCta": "Freund einladen für +{n}",
  "creditsTopUpCta": "Credits kaufen",
  "inviteMenu": "Freunde einladen",
  "profileShare": "Teilen",
  "profileShareText": "Sieh dir die Designs von {name} auf archelier an.",
  "original": "Original",
  "aiDesign": "KI-Design",
  "imageGenFailed": "Bildgenerierung für dieses Foto fehlgeschlagen",
  "seeAnalysis": "Siehe Design-Analyse unten.",
  "analysisTitle": "Innendesign-Analyse",
  "spaceAnalysis": "Raumanalyse",
  "styleDescription": "Stilbeschreibung",
  "colorPalette": "Farbpalette",
  "furnitureRec": "Möbelempfehlungen",
  "shopFor": "{item} shoppen",
  "shopShort": "Shoppen",
  "paintMatch": "Ähnlichste Farbe",
  "paintCodeCopy": "Farbcode kopieren",
  "paintCodeCopied": "Code kopiert",
  "editRegion": "Bereich bearbeiten",
  "editRegionTitle": "Design bearbeiten",
  "editRegionDesc": "Sag der KI, was geändert und was stattdessen eingefügt werden soll. Der Rest des Raums bleibt gleich.",
  "editRegionBrushHint": "Sag der KI, was geändert oder ergänzt werden soll. Für einzelne Stellen markiere sie zuerst mit dem Pinsel – sonst wird das ganze Bild bearbeitet. Zum Entfernen markieren und „entfernen“ schreiben.",
  "editRegionMeta": "Als neues Design gespeichert · {n} Credits",
  "editedFromBanner": "Dies ist eine bearbeitete Kopie.",
  "viewOriginal": "Original anzeigen",
  "editsOfThisDesign": "Bearbeitungen dieses Designs",
  "editsOfThisDesignDesc": "Designs, die du durch Bearbeiten dieses Designs erstellt hast.",
  "chatTitle": "KI-Designberater",
  "chatHint": "Stelle Fragen zu diesem Raum. Die KI sieht dein Design und bezieht sich darauf.",
  "chatStart": "Chat starten",
  "chatPlaceholder": "Frage nach Möbeln, Farben oder Layout-Ideen…",
  "chatSend": "Senden",
  "chatSending": "Denkt nach…",
  "chatSuggestion1": "Welche Lampe würde den Raum wärmer wirken lassen?",
  "chatSuggestion2": "Wie kann ich den Raum größer wirken lassen?",
  "chatSuggestion3": "Welche 3 Dinge sollte ich zuerst ändern?",
  "chatTurnsRemaining": "Noch {n} Fragen für dieses Design",
  "chatTurnsExhausted": "Du hast das Chat-Limit für dieses Design erreicht. Erstelle ein neues Design, um weiterzusprechen.",
  "chatErrGeneric": "Der Berater konnte nicht antworten. Bitte versuche es erneut.",
  "chatPro": "Pro — unbegrenzter Chat",
  "chatRetry": "Erneut versuchen",
  "commentsTitle": "Kommentare",
  "commentPlaceholder": "Kommentar hinzufügen",
  "commentPost": "Posten",
  "commentPosting": "Wird gepostet…",
  "commentSignInHint": "Melde dich an, um einen Kommentar zu schreiben.",
  "commentEmpty": "Noch keine Kommentare.",
  "commentDelete": "Löschen",
  "commentDeleteConfirm": "Diesen Kommentar löschen?",
  "commentTooLong": "Kommentare sind auf 500 Zeichen begrenzt.",
  "commentErrGeneric": "Kommentar konnte nicht gepostet werden. Bitte versuche es erneut.",
  "commentCount": "{n}",
  "bookmarksTitle": "Meine Kollektionen",
  "tabDesigns": "Designs",
  "tabCollections": "Kollektionen",
  "bookmarksSectionTitle": "Gespeicherte Designs",
  "bookmarksEmpty": "Noch keine Kollektionen. Speichere ein Design, um ein Board zu erstellen.",
  "bookmarksAdd": "Speichern",
  "bookmarksAdded": "Gespeichert",
  "bookmarksRemove": "Aus Gespeichert entfernen",
  "bookmarksSignInHint": "Melde dich an, um Designs zu speichern.",
  "saved": "Gespeichert",
  "savedCollectionDefault": "Gespeichert",
  "follow": "Folgen",
  "unfollow": "Entfolgen",
  "following": "Folge ich",
  "followers": "Follower",
  "followingTab": "Folge ich",
  "followingEmpty": "Folge anderen, um ihre neuesten Designs hier zu sehen.",
  "followersEmpty": "Noch keine Follower.",
  "followingEmpty2": "Du folgst noch niemandem.",
  "followSignInHint": "Melde dich an, um zu folgen",
  "cannotFollowSelf": "Du kannst dir nicht selbst folgen.",
  "profile": "Profil",
  "profileNotFound": "Dieses Profil existiert nicht.",
  "profileDesigns": "Designs",
  "profileDesignsCount": "Designs",
  "profileFollowers": "Follower",
  "profileFollowing": "Gefolgt",
  "profileBio": "Bio",
  "profileEdit": "Profil bearbeiten",
  "profileMyProfile": "Mein Profil",
  "displayNameLabel": "Anzeigename",
  "displayNamePlaceholder": "Dein Name oder Studio (optional)",
  "displayNameSave": "Name speichern",
  "displayNameSaved": "Name gespeichert",
  "displayNameErrGeneric": "Name konnte nicht gespeichert werden. Bitte versuche es erneut.",
  "handleLabel": "Nutzername",
  "handlePlaceholder": "Kleinbuchstaben, Ziffern, Unterstrich (3–20 Zeichen)",
  "handleSave": "Nutzername speichern",
  "handleSaved": "Nutzername gespeichert",
  "handleInvalid": "Nutzername muss 3–20 Zeichen lang sein: a-z, 0-9, Unterstrich.",
  "handleTaken": "Dieser Nutzername ist bereits vergeben.",
  "handleErrGeneric": "Nutzername konnte nicht gespeichert werden. Bitte versuche es erneut.",
  "bioPlaceholder": "Erzähle etwas über dich (max. 200 Zeichen)",
  "bioSave": "Bio speichern",
  "bioSaved": "Bio gespeichert",
  "bioErrGeneric": "Bio konnte nicht gespeichert werden. Bitte versuche es erneut.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "dein_instagram_nutzername",
  "instagramInvalid": "Nur Buchstaben, Ziffern, Punkte oder Unterstriche (max. 30).",
  "profileNoDesigns": "Noch keine Designs.",
  "collections": "Kollektionen",
  "collectionsTab": "Kollektionen",
  "collectionMine": "Meine Kollektionen",
  "collectionEmpty": "Noch keine Kollektionen.",
  "collectionPublicEmpty": "Keine öffentlichen Kollektionen.",
  "collectionItemCount": "{n} Elemente",
  "collectionEmpty2": "Diese Kollektion ist leer.",
  "newCollection": "Neue Kollektion",
  "collectionNamePlaceholder": "Name der Kollektion (z. B. Wohnzimmer-Ideen)",
  "collectionCreate": "Erstellen",
  "collectionDelete": "Kollektion löschen",
  "collectionDeleteConfirm": "Diese Kollektion löschen? Die Elemente werden entfernt.",
  "collectionRename": "Kollektion umbenennen",
  "collectionVisibility": "Öffentliche Kollektion",
  "collectionVisibilityOn": "Jeder mit dem Link kann sie ansehen",
  "collectionVisibilityOff": "Nur du kannst diese Kollektion sehen",
  "addToCollection": "Zur Kollektion hinzufügen",
  "saveToCollection": "In Kollektion speichern",
  "collectionAdded": "Hinzugefügt",
  "collectionRemoveFromBoard": "Aus Kollektion entfernen",
  "collectionShareLink": "Kollektions-Link kopieren",
  "collectionByOwner": "von",
  "collectionNotFound": "Diese Kollektion existiert nicht oder ist privat.",
  "collectionErrCreate": "Kollektion konnte nicht erstellt werden.",
  "collectionErrSave": "Kollektion konnte nicht aktualisiert werden.",
  "collectionDone": "Fertig",
  "collectionPickerHint": "Tippe auf eine Kollektion, um dieses Design hinzuzufügen oder zu entfernen.",
  "uploadAcceptsHint": "Fotos funktionieren am besten, aber auch Skizzen, Aufrisse, Grundrisse und 3D-Screenshots klappen.",
  "examplePhotos": "Beispielfotos",
  "detectedInputTypes": {
    "sketch": "Skizze",
    "elevation": "Aufriss",
    "floorplan": "Grundriss",
    "3d_model": "3D-Modell"
  },
  "floorplanDetectedBanner": "Sieht nach einem Grundriss aus – der größte Gemeinschaftsraum wurde auf Augenhöhe gerendert. Um einen bestimmten Raum zu wählen, füge nächstes Mal einen Hinweis hinzu (z. B. „Schlafzimmer rendern“).",
  "floorplanDetectedBannerWithRoom": "Sieht nach einem Grundriss aus – {room} auf Augenhöhe gerendert. Für einen anderen Raum, füge nächstes Mal eine Notiz hinzu.",
  "spaceCategoryTitle": "Was gestaltest du?",
  "spaceCategories": {
    "interior": "Innenbereich",
    "exterior": "Außenbereich",
    "garden": "Garten"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Kürbisse, Laternen, herbstliche Veranda"
    },
    "christmas": {
      "name": "Weihnachten",
      "description": "Kränze, warme Lichterketten, Tannengirlande"
    },
    "lunar_new_year": {
      "name": "Mondneujahr",
      "description": "Rote Laternen, Gold, Glücksverse"
    },
    "spring_blossom": {
      "name": "Frühlingsblüte",
      "description": "Blühende Bäume, Pastellbeete, klares Licht"
    },
    "modern_facade": {
      "name": "Moderne Fassade",
      "description": "Klare Geometrie, viel Glas, Materialmix"
    },
    "modern_farmhouse": {
      "name": "Modern Farmhouse",
      "description": "Weiße Fassade, schwarze Akzente, Holzdetails"
    },
    "mediterranean": {
      "name": "Mediterran",
      "description": "Putz, Terrakotta, Rundbögen"
    },
    "craftsman": {
      "name": "Craftsman",
      "description": "Holzschindeln, flache Giebel, offene Dachsparren"
    },
    "contemporary": {
      "name": "Zeitgenössisch",
      "description": "Scharfe Linien, kühne Formen, Industriematerialien"
    },
    "minimalist_exterior": {
      "name": "Minimalistischer Außenbereich",
      "description": "Dezente Farben, Fokus auf ein Material"
    },
    "tudor": {
      "name": "Tudor-Stil",
      "description": "Englischer Tudor-Stil – Fachwerk mit steilen Giebeln"
    },
    "cape_cod": {
      "name": "Cape Cod",
      "description": "Neuengland-Stil – weiße Schindeln, schwarze Läden"
    },
    "japanese_traditional": {
      "name": "Traditionell Japanisch",
      "description": "Minka-Holzrahmen mit Ziegeldach und Engawa"
    },
    "mountain_cabin": {
      "name": "Berghütte",
      "description": "A-Frame aus Holz oder Blockhütte in der Natur"
    },
    "midcentury_exterior": {
      "name": "Mid-Century-Außenbereich",
      "description": "Moderne der 50er/60er – Flachdach, viel Glas, horizontale Linien"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Kürbisbeet, Laternen, nebliger Herbstgarten"
    },
    "christmas": {
      "name": "Weihnachten",
      "description": "Beleuchtete Tannen, warmes Licht, Wintergarten"
    },
    "lunar_new_year": {
      "name": "Mondneujahr",
      "description": "Rote Laternen, Blütenzweige, Glücksgarten"
    },
    "spring_blossom": {
      "name": "Frühlingsblüte",
      "description": "Kirschblüte, Tulpen, frisches Frühlingsgrün"
    },
    "modern": {
      "name": "Moderner Garten",
      "description": "Klare Geometrie, Betonplatten, Ziergräser"
    },
    "mediterranean": {
      "name": "Mediterran",
      "description": "Kies, Oliven & Lavendel, Terrakotta, Pergola"
    },
    "coastal": {
      "name": "Küsten-Stil",
      "description": "Gräser, Treibholz, salzresistente Pflanzen"
    },
    "minimalist": {
      "name": "Minimalistisch",
      "description": "Ein Material, eine Pflanzenart, Freiräume"
    },
    "zen": {
      "name": "Zengarten",
      "description": "Geharkter Kies, Steine, dezente Bepflanzung"
    },
    "cottage": {
      "name": "Cottage-Garten",
      "description": "Romantisch, dichte Bepflanzung, Staudenmix"
    },
    "desert": {
      "name": "Wüste / Xeriscape",
      "description": "Trockenresistent, Sukkulenten, Kies"
    },
    "tropical": {
      "name": "Tropisch",
      "description": "Üppiges Grün, große Blätter, bunte Blüten"
    },
    "english": {
      "name": "Englischer Garten",
      "description": "Gepflegter Rasen, Hecken, gestaffelte Beete"
    }
  },
  "seasonLabel": "Jahreszeit",
  "seasons": {
    "none": "Beliebig",
    "spring": "Frühling",
    "summer": "Sommer",
    "autumn": "Herbst",
    "winter": "Winter"
  },
  "timeOfDayLabel": "Tageszeit",
  "timesOfDay": {
    "none": "Beliebig",
    "day": "Tageslicht",
    "golden_hour": "Goldene Stunde",
    "night": "Nacht"
  },
  "editRegionReplacementLabel": "Was soll geändert werden?",
  "editRegionReplacementPlaceholder": "z. B. große Statue neben der Eingangstür",
  "editRegionSubmit": "Bearbeitung generieren",
  "editRegionGenerating": "Bearbeitetes Bild wird generiert…",
  "editRegionMaskRequired": "Markiere zuerst den Bereich, den du ändern möchtest.",
  "editRegionReplacementRequired": "Sag uns, was dort hin soll.",
  "editRegionBrush": "Pinsel",
  "editRegionUndo": "Rückgängig",
  "editRegionSize": "Größe",
  "editRegionClear": "Zurücksetzen",
  "errEditGeneric": "Bearbeitung fehlgeschlagen. Bitte versuche es erneut.",
  "lightingPlan": "Lichtplan",
  "designTips": "Design-Tipps",
  "startNew": "Neues Design starten",
  "viewMyDesigns": "Meine Designs ansehen",
  "favorite": "Favorisieren",
  "unfavorite": "Aus Favoriten entfernen",
  "rename": "Umbenennen",
  "savePromptText": "Melde dich an, um dieses Design zu speichern, zu teilen und mehr zu erstellen",
  "guestCreditsLeft": "Nur noch {n} freies Design übrig. Melde dich an und starte mit {total}.",
  "guestCreditsGone": "Das war dein letztes freies Design. Melde dich an und erhalte {total}.",
  "signInGoogle": "Mit Google anmelden",
  "signInApple": "Mit Apple anmelden",
  "signInDesc": "Speichere deine Designs und greife jederzeit darauf zu.",
  "signInPopupBlocked": "Popup wurde blockiert. Bitte erlaube Popups in deinen Browsereinstellungen.",
  "appName": "archelier",
  "navCreate": "Erstellen",
  "navGallery": "Galerie",
  "navGio": "Designer",
  "navMain": "Hauptnavigation",
  "packsTitle": "Aufladen",
  "packDesigns": "ca. {n} Designs",
  "packBuying": "Öffnen…",
  "packWaiting": "Zahlung erfolgt — Credits werden hinzugefügt…",
  "packDone": "Credits hinzugefügt.",
  "packSlow": "Deine Credits sind unterwegs. Sie erscheinen in Kürze — kein erneuter Kauf nötig.",
  "packFailed": "Kauf fehlgeschlagen. Falls abgebucht wurde und keine Credits kommen, kontaktiere den Support.",
  "gioRole": "Raum-Designer",
  "gioAiNote": "KI",
  "gioSignInBody": "Melde dich an, um mit Gio zu chatten. Gio analysiert deine Raumfotos und früheren Designs, schlägt Stile vor und erstellt oder bearbeitet Designs direkt im Chat.",
  "gioGreeting": "Hi, ich bin Gio. Sende mir ein Foto deines Raums, ein Bild oder einen Link zu einem Raum, den du magst, oder ein altes Design — ich schlage dir Stile vor und erstelle dein Design.",
  "gioChipTaste": "Was ist mein Stil?",
  "gioChipTrend": "Was ist diese Woche im Trend?",
  "gioChipPhoto": "Raumfoto senden",
  "gioChipMine": "Eigenes Design nutzen",
  "gioTyping": "Gio überlegt…",
  "gioPlaceholder": "Frage Gio oder füge einen Link ein",
  "gioSend": "Senden",
  "gioAttachPhoto": "Foto anhängen",
  "gioPickDesign": "Meine Designs",
  "gioPickEmpty": "Noch keine Designs — erstelle zuerst eins und wähle es hier aus.",
  "gioRemove": "Entfernen",
  "gioToday": "Heute",
  "gioNoCredits": "Keine Credits mehr.",
  "gioError": "Gio konnte gerade nicht antworten. Bitte versuche es erneut.",
  "gioAlreadyStarting": "Startet bereits — einen Moment bitte.",
  "gioPhotoSkipped": "Einige Fotos konnten nicht hinzugefügt werden. Du kannst bis zu {n} Fotos anhängen (JPG, PNG, WebP oder HEIC, unter 20 MB).",
  "gioErrPhotos": "Die Fotos hierfür wurden nicht gefunden. Füge ein Foto deines Raums hinzu und versuche es erneut.",
  "gioErrPrompt": "Gio konnte daraus kein Design erstellen. Versuche, es etwas anders zu beschreiben.",
  "gioErrGone": "Dieses Design oder dieser Vorschlag ist nicht mehr verfügbar.",
  "gioCreditsLow": "Noch {n} Credits · {c} pro Nachricht, {p} mit Foto",
  "gioCreditsLowFree": "Noch {n} Credits · Chat mit Gio ist kostenlos",
  "gioNoCreditsChatFree": "Du hast keine Credits mehr für Designs – der Chat bleibt kostenlos.",
  "gioDailyLimit": "Das war viel Chatten für einen Tag. Lass uns morgen weitermachen.",
  "gioCardEdit": "Bearbeiten",
  "gioCardPhotos": "Fotos bereit: {n}",
  "gioCardPhotoFromDesign": "Foto aus deinem Entwurf vom {date}",
  "gioCardPhotoFromDesignNoDate": "Foto aus einem deiner Entwürfe",
  "gioCardPhotoFromChat": "Hier geteiltes Foto",
  "gioCardPhotoNew": "Neues Foto",
  "gioCardNoPhoto": "Noch kein Foto",
  "gioCardChangePhoto": "Ändern",
  "gioCardAddPhoto": "Foto hinzufügen",
  "gioCardUploading": "Wird hochgeladen…",
  "gioCardSame": "Du hast bereits einen {style}-Entwurf von diesem Foto ({date}).",
  "gioCardSameView": "Ansehen",
  "gioCardSameHint": "Mit demselben Wunsch wird das Ergebnis sehr ähnlich. Für Änderungen füge oben einen Wunsch hinzu, sag es Gio im Chat oder öffne es in Erstellen.",
  "gioPickPhoto": "Foto auswählen",
  "gioPickUpload": "Neues Foto hochladen",
  "gioRunEdit": "Bearbeiten · {n} Credits",
  "gioRunGenerate": "Erstellen · {n} Credits",
  "gioRunWithPhoto": "Foto hinzufügen & erstellen · {n}/Foto",
  "gioOpenInCreate": "In 'Erstellen' öffnen",
  "gioPaintMyself": "Bereich selbst markieren",
  "gioStarting": "Startet…",
  "gioJobMaking": "Design wird erstellt…",
  "gioJobEditing": "Design wird bearbeitet…",
  "gioJobNotify": "Du kannst gehen — ich gebe Bescheid, wenn es fertig ist.",
  "gioJobInvalid": "Das Foto sieht nicht nach einem Raum aus, den ich gestalten kann.",
  "gioJobFailed": "Das konnte ich nicht fertigstellen.",
  "gioJobRefunded": "Deine Credits wurden erstattet.",
  "gioJobDone": "Fertig — schau es dir an",
  "gioJobGone": "Dieses Design wurde gelöscht.",
  "gioAskAboutDesign": "Gio zu diesem Design fragen",
  "navFeed": "Feed",
  "navMy": "Meine",
  "navAccount": "Einstellungen",
  "signIn": "Anmelden",
  "signOut": "Abmelden",
  "deleteAccount": "Konto löschen",
  "deleteAccountTitle": "Konto löschen?",
  "deleteAccountWarn": "Dies löscht dein Konto und alle damit verknüpften Daten dauerhaft. Diese Aktion kann nicht rückgängig gemacht werden.",
  "deleteAccountItem_designs": "Alle deine Designs, Bilder und Unterhaltungen mit Gio",
  "deleteAccountItem_profile": "Dein Profil, Benutzername und gespeicherte Stile",
  "deleteAccountItem_social": "Kommentare, Likes, Follows und Sammlungen",
  "deleteAccountItem_credits": "Verbleibendes Guthaben, inklusive gekaufter Credits, und Abo-Verlauf",
  "deleteAccountBilling_web": "Dein aktives Web-Abo wird automatisch gekündigt.",
  "deleteAccountBilling_ios": "Dein App Store- oder Google Play-Abo wird nicht automatisch gekündigt — bitte kündige es in den Abo-Einstellungen deines Stores.",
  "deleteAccountFinal": "Du wirst sofort abgemeldet und kannst dieses Konto nicht wiederherstellen.",
  "deleteAccountConfirm": "Konto löschen",
  "deleteAccountSubmitting": "Wird gelöscht…",
  "deleteAccountError": "Konto konnte nicht gelöscht werden. Bitte versuche es erneut.",
  "myDesigns": "Meine Designs",
  "language": "Sprache",
  "support": "Support",
  "terms": "Nutzungsbedingungen",
  "privacy": "Datenschutzerklärung",
  "signInTerms": "Mit der Anmeldung stimmst du unseren {terms} und unserer {privacy} zu.",
  "onboardingSkip": "Überspringen",
  "onboardingNext": "Weiter",
  "onboardingStart": "Loslegen",
  "tourTitle": "Tour durch archelier",
  "tourCreate": "Starte hier. Fotografiere oder lade einen Raum, Außenbereich oder Garten hoch, wähle einen Stil und kurz darauf ist dein neues Design da.",
  "tourGallery": "Galerie – die diese Woche beliebtesten Stile auf archelier. Tippe auf einen, um ihn in deinem Raum auszuprobieren.",
  "tourGio": "Gio ist dein Designer. Zeige ein Foto und sag, was du möchtest – Gio schlägt Stile vor und erstellt oder bearbeitet das Design für dich.",
  "tourMy": "Deine Designs findest du unter Meine. Passe einzelne Bereiche an, indem du sie übermalst oder beschreibst, und lade sie herunter oder teile sie.",
  "tourStart": "Komm für ein neues Design jederzeit zu diesem Button zurück. Fangen wir mit einem Foto an.",
  "tourReplay": "Tour wiederholen",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Fotografieren, skizzieren oder hochladen",
      "desc": "Ein Handyfoto funktioniert am besten, aber archelier erkennt auch Handskizzen, Aufrisse, Grundrisse und 3D-Modell-Screenshots automatisch."
    },
    {
      "icon": "style",
      "title": "Über 19 Stile, 4 smarte Modi",
      "desc": "Wähle einen Stil, schreibe einen eigenen Prompt, nutze ein Referenzfoto oder verwende die Modi Cleanup / Layout zum Aufräumen und Umgestalten."
    },
    {
      "icon": "brush",
      "title": "Nur den gewünschten Teil bearbeiten",
      "desc": "Gefällt dir eine Ecke nicht? Überpinsle sie im Ergebnis und sag der KI, was dort hin soll. Der Rest des Raumes bleibt pixelgenau gleich."
    },
    {
      "icon": "auto_awesome",
      "title": "Jetzt ausprobieren",
      "desc": "Du bekommst jeden Tag kostenlose Credits. Lade ein Foto hoch und dein erstes Design ist in etwa einer Minute fertig."
    }
  ],
  "onboardTabFeedTitle": "Zuerst stöbern",
  "onboardTabFeedDesc": "Sieh dir an, was andere entworfen haben, und lass dich für deinen eigenen Raum inspirieren.",
  "onboardTabCreateTitle": "Mit KI designen",
  "onboardTabCreateDesc": "Lade ein Foto, eine Skizze oder einen Plan hoch – die KI erstellt ein neues Design.",
  "onboardTabMyTitle": "Speichern & verwalten",
  "onboardTabMyDesc": "Hier werden deine Designs gesammelt. Teile sie im Feed oder lade sie jederzeit herunter.",
  "onboardTabGioTitle": "Gio fragen",
  "onboardTabGioDesc": "Gio, unser Raum-Designer, schlägt Stile anhand deiner Fotos vor und erstellt oder bearbeitet Designs direkt im Chat.",
  "myDesignsTitle": "Meine Designs",
  "signInToSee": "Melde dich an, um deine Designs zu sehen",
  "signInToSeeDesc": "Deine gespeicherten Designs werden hier angezeigt.",
  "loadingDesigns": "Designs werden geladen…",
  "errLoadDesigns": "Designs konnten nicht geladen werden. Bitte versuche es noch einmal.",
  "retry": "Wiederholen",
  "noFavorites": "Noch keine Favoriten.",
  "noDesigns": "Noch keine Designs. Erstelle dein erstes!",
  "createDesign": "Design erstellen",
  "loadMore": "Mehr laden",
  "loading": "Lädt…",
  "errDesignNotFound": "Design nicht gefunden.",
  "errLoadDesign": "Design konnte nicht geladen werden.",
  "errDeleteDesign": "Löschen fehlgeschlagen. Bitte versuche es noch einmal.",
  "renameTitle": "Design umbenennen",
  "renamePlaceholders": [
    "Wohnzimmer-Redesign v1",
    "Küche — helle Version",
    "Studio-Makeover",
    "Schlafzimmer, warme Töne",
    "Balkon Plan B",
    "Homeoffice-Einrichtung",
    "Café-Design Entwurf",
    "Vorgarten v2"
  ],
  "save": "Speichern",
  "cancel": "Abbrechen",
  "deleteTitle": "Design löschen?",
  "deleteDesc": "Dadurch werden dieses Design und alle zugehörigen Bilder dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.",
  "delete": "Löschen",
  "deleting": "Wird gelöscht…",
  "postToFeed": "Im Feed posten",
  "postedToFeedTitle": "Im Feed gepostet",
  "postedToFeedDesc": "Andere Nutzer können dieses Design jetzt im Feed sehen und liken.",
  "captionTitle": "Beschreibung hinzufügen",
  "captionPlaceholder": "Teile, warum du diesen Raum neu gestaltet hast (optional)",
  "captionEdit": "Beschreibung bearbeiten",
  "captionPost": "Posten",
  "captionSave": "Speichern",
  "captionCancel": "Abbrechen",
  "viewFeed": "Feed ansehen",
  "generationInProgress": "Dein Raum wird gestaltet…",
  "generationKeepBrowsing": "Stöbere ruhig weiter – wir geben dir Bescheid, wenn es fertig ist",
  "generationDone": "Dein Design ist fertig!",
  "generationTapToOpen": "Tippe auf Öffnen, um es anzusehen",
  "generationFailedHint": "Dein Credit wurde nicht abgebucht. Bitte versuche es noch einmal.",
  "open": "Öffnen",
  "copy": "Kopieren",
  "copied": "Kopiert!",
  "share": "Teilen",
  "downloadImages": "KI-Bilder herunterladen",
  "download": "Herunterladen",
  "downloadWatermarkHint": "Eine kleine archelier-Signatur befindet sich in der rechten unteren Ecke.",
  "modes": {
    "redesign": "Redesign",
    "staging": "Staging leerer Räume"
  },
  "styleUsed": "Verwendeter Stil",
  "customDescLabel": "Eigene Beschreibung:",
  "additionalReqLabel": "Zusätzliche Wünsche:",
  "useStyleAgain": "Stil erneut verwenden",
  "feedTitle": "Community",
  "feedEmpty": "Noch keine öffentlichen Designs. Mach den Anfang!",
  "feedSortLatest": "Neueste",
  "feedSortPopular": "Beliebt",
  "feedFilterAll": "Alle",
  "useThisStyle": "Stil ausprobieren",
  "sourceDesignBanner": "Basiert auf „{name}“",
  "galleryPickBanner": "Gestalten mit {name}",
  "signInToLike": "Anmelden, um Designs zu liken",
  "tryApp": "archelier ausprobieren",
  "privateTitle": "Dieses Design ist privat",
  "privateDesc": "Der Ersteller hat dieses Design nicht veröffentlicht.",
  "linkNotFoundTitle": "Dieser Link ist nicht verfügbar",
  "linkNotFoundDesc": "Das Design wurde vielleicht gelöscht oder der Link ist unvollständig.",
  "createWithApp": "Mit archelier erstellen",
  "shareViewCTA": "Möchtest du deinen Raum neu gestalten?",
  "styles": {
    "modern": {
      "name": "Modern",
      "description": "Klare Linien, neutrale Töne, minimalistisch-modern"
    },
    "scandinavian": {
      "name": "Skandinavisch",
      "description": "Hell, natürliche Materialien, gemütliche nordische Wärme"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Funktional, erschwinglich, cleveres skandinavisches Design"
    },
    "japandi": {
      "name": "Japandi",
      "description": "Japanischer Minimalismus trifft skandinavische Wärme"
    },
    "industrial": {
      "name": "Industrial",
      "description": "Rohe Materialien, offene Elemente, urbane Loft-Ästhetik"
    },
    "coastal": {
      "name": "Coastal",
      "description": "Luftige, lichtdurchflutete Strandhaus-Eleganz"
    },
    "classic": {
      "name": "Klassisch",
      "description": "Zeitlose Eleganz, edle Stoffe, verzierte Details"
    },
    "artdeco": {
      "name": "Art Deco",
      "description": "Kühne Geometrie, Goldakzente, opulenter Glamour der 1920er"
    },
    "midcentury": {
      "name": "Mid-Century Modern",
      "description": "Organische Formen, warmes Holz, Retro-Charme der 50er und 60er"
    },
    "maximalist": {
      "name": "Maximalistisch",
      "description": "Auffällige Muster, üppige Lagen, Mehr-ist-mehr-Philosophie"
    },
    "vintage": {
      "name": "Vintage",
      "description": "Nostalgischer Charme, antike Fundstücke, warme Retro-Farben"
    },
    "bohemian": {
      "name": "Bohemian",
      "description": "Unbeschwert, bunte Textilien, künstlerische Eklektik"
    },
    "tropical": {
      "name": "Tropisch",
      "description": "Üppiges Grün, Rattan, luftiges Urlaubsflair"
    },
    "cottagecore": {
      "name": "Cottagecore",
      "description": "Romantisches englisches Landleben, Blumen, sanfte Pastelltöne"
    },
    "rustic": {
      "name": "Rustikal",
      "description": "Verwittertes Holz, Stein, gemütlicher Landhaus-Charme"
    },
    "wabisabi": {
      "name": "Wabi-Sabi",
      "description": "Unvollkommene Schönheit, raue Texturen, stille japanische Askese"
    },
    "gothic": {
      "name": "Gothic",
      "description": "Düsteres Drama, Samt, kunstvolle Silhouetten"
    },
    "cyberpunk": {
      "name": "Cyberpunk",
      "description": "Neon-Futurismus, Hightech-Oberflächen, urbane Dystopie"
    },
    "taisho_romance": {
      "name": "Taisho Romance",
      "description": "Japan des frühen 20. Jahrhunderts trifft auf westlichen Jugendstil"
    },
    "biophilic": {
      "name": "Biophil",
      "description": "Pflanzen überall, natürliches Licht, organische Texturen"
    },
    "cozy": {
      "name": "Gemütlich",
      "description": "Warm, weich, einladend – Komfort im Hygge-Stil"
    },
    "gaming": {
      "name": "Gaming",
      "description": "RGB-Setup, smarte Technik, immersive Gaming-Station"
    },
    "minimalist": {
      "name": "Minimalistisch",
      "description": "Reduziert, ordentlich, freie Flächen"
    },
    "mediterranean": {
      "name": "Mediterran",
      "description": "Kalkwände, Terrakotta, Bögen, Naturstein"
    },
    "luxury": {
      "name": "Quiet Luxury",
      "description": "Edle Materialien, dezente Farben, unaufdringlich"
    },
    "dark_academia": {
      "name": "Dark Academia",
      "description": "Düstere Bibliothek – Ochsenblutrot, Messing, Buchstapel"
    },
    "organic_modern": {
      "name": "Organic Modern",
      "description": "Moderne Formen aus rohen Naturmaterialien"
    },
    "farmhouse": {
      "name": "Farmhouse",
      "description": "Holzverkleidung, Spülstein, Altholz, warmer Landhausstil"
    },
    "halloween": {
      "name": "Halloween",
      "description": "Kürbisse, Kerzen, herbstliche Düsterkeit"
    },
    "christmas": {
      "name": "Weihnachten",
      "description": "Baum, Girlanden, warmes Licht, festliche Deko"
    },
    "lunar_new_year": {
      "name": "Mondneujahr",
      "description": "Rot und Gold, Lampions, Glückssymbole"
    },
    "spring_blossom": {
      "name": "Frühlingsblüte",
      "description": "Kirschblüten, Pastelltöne, frisches, luftiges Licht"
    },
    "custom": {
      "name": "Eigener Stil",
      "description": "Beschreibe deine eigene, einzigartige Vision"
    },
    "reference": {
      "name": "Referenz",
      "description": "Übernimm Farben, Materialien und Stimmung eines Fotos"
    },
    "floorplan": {
      "name": "Grundriss",
      "description": "Ein 3D-Grundriss oder eine saubere Zeichnung deines Grundrisses"
    },
    "cleanup": {
      "name": "Aufräumen",
      "description": "Unordnung beseitigen oder Raum leeren – deine Wahl"
    },
    "layout": {
      "name": "Layout",
      "description": "Gleiche Möbel, bessere Platzierung – harmonisch oder geräumig"
    }
  },
  "langMismatchNotice": "Diese Analyse wurde auf {lang} erstellt.",
  "pricingTitle": "Tarife, die mit dir wachsen",
  "pricingSubtitle": "Kostenlos starten. Upgrade für mehr Designs und Premium-Funktionen.",
  "pricePerMonth": "/ Monat",
  "trialCta": "Jetzt {n} Tage kostenlos testen",
  "accountPlanFreeTitle": "Dein Konto ist KOSTENLOS",
  "accountPlanProTitle": "Du nutzt Pro",
  "accountPlanTrialTitle": "Du nutzt Pro – Kostenlose Testversion",
  "proTrialBadge": "Testversion",
  "proTrialDaysLeft": "Noch {n} Tage in deiner Testversion",
  "proTrialIntroTitle": "Hol dir 2 Wochen Pro – kostenlos",
  "proTrialIntroDesc": "Registriere dich und starte mit {n} kostenlosen Credits.",
  "proTrialFeatures": "Danach täglich {n} weitere gratis. Ohne Abo, für immer.",
  "welcomeSkip": "Ohne Konto fortfahren",
  "landingHeadline": "gestalte jeden Raum neu, in Sekunden.",
  "landingTagline": "Foto machen, Stil wählen, fotorealistisches Design erhalten. Täglich kostenlos, kein Abo.",
  "landingOpenWeb": "Oder im Web fortfahren →",
  "landingFeat1": "KI-Raumdesigns",
  "landingFeat2": "Fotorealistisch",
  "landingFeat3": "Über 50 Stile",
  "landingFeat4": "Garten & Außenbereich",
  "landingFeat5": "Täglich kostenlos",
  "landingStoreOn": "Laden im",
  "landingStoreGet": "Jetzt bei",
  "lp": {
    "metaTitle": "archelier – KI-Innendesign aus Foto, Skizze oder Grundriss",
    "metaDescription": "Fotografiere einen Raum und erhalte in ca. einer Minute ein fotorealistisches Redesign. 48 Stile für Innen, Außen und Garten, 3D-Grundrisse, Pinsel-Edits und ein KI-Designer im Chat. Jeden Tag kostenlos.",
    "heroEyebrow": "KI-Innendesign",
    "scrollCue": "So funktioniert’s",
    "webCta": "Kostenlos im Browser testen",
    "orApp": "Oder hol dir die App",
    "qrHint": "Mit der Handykamera scannen. Die App gibt dir Bescheid, sobald dein Design fertig ist.",
    "showEyebrow": "Vorher & Nachher",
    "showTitle": "Ein Foto. Ein völlig neuer Raum.",
    "showBody": "Echte Ergebnisse mit archelier. Zum Vergleichen ziehen.",
    "before": "Vorher",
    "after": "Nachher",
    "tabRoom": "Wohnzimmer",
    "tabEmpty": "Leerer Raum",
    "tabSketch": "Skizze",
    "tabPlan": "Grundriss",
    "tabExterior": "Außenbereich",
    "capRoom": "Rustikal – dieselbe Küche und dasselbe Wohnzimmer, nur wärmer.",
    "capEmpty": "Skandinavisch – ein leerer Raum, komplett eingerichtet.",
    "capSketch": "Japandi – eine Strichzeichnung als realer Raum gerendert.",
    "capPlan": "Grundriss-Modus – ein 2D-Plan als 3D-Ansicht des ganzen Hauses.",
    "capExterior": "Minimalistisch – eine unruhige Ladenfront, neu gestaltet.",
    "howEyebrow": "So funktioniert’s",
    "howTitle": "Drei Schritte, etwa eine Minute.",
    "how1Title": "Foto machen",
    "how1Body": "Jeder Raum, wie er ist – oder eine Skizze, ein Grundriss oder ein 3D-Screenshot. Bis zu 3 Blickwinkel desselben Raums.",
    "how2Title": "Stil wählen",
    "how2Body": "Wähle einen von 48 Stilen, beschreibe deinen eigenen in einem Satz oder lade ein Inspofoto hoch.",
    "how3Title": "Design erhalten",
    "how3Body": "Ein fotorealistisches Rendering deines Raums mit Möbel-Liste, Farbpalette und Lichtkonzept.",
    "stylesEyebrow": "Stile",
    "stylesTitle": "48 Stile, drei Raumarten.",
    "stylesBody": "28 für Innenräume, 11 für Außenbereiche, 9 für Gärten – plus saisonale Looks für Halloween, Weihnachten, Mondneujahr und Frühling.",
    "stylesInterior": "Innen",
    "stylesExterior": "Außen",
    "stylesGarden": "Garten",
    "stylesCta": "Stil-Galerie durchstöbern",
    "modesEyebrow": "Mehr als Stile",
    "modesTitle": "Fünf weitere Wege, einen Raum zu gestalten.",
    "modeCustomTitle": "Eigener Stil",
    "modeCustomBody": "Beschreibe den Look in einem Satz und speichere ihn für später.",
    "modeReferenceTitle": "Referenz",
    "modeReferenceBody": "Lade ein Lieblingsfoto hoch und übernimm Stimmung, Materialien und Palette – nicht das Layout.",
    "modeCleanupTitle": "Aufräumen",
    "modeCleanupBody": "Beseitige Unordnung und sieh den Raum im Urzustand.",
    "modeLayoutTitle": "Layout",
    "modeLayoutBody": "Richte vorhandene Möbel neu aus, statt sie zu ersetzen.",
    "modePlanTitle": "Grundriss",
    "modePlanBody": "Wandle einen Grundriss in eine 3D-Ansicht um oder eine grobe Skizze in eine saubere Zeichnung.",
    "editEyebrow": "Pinsel-Bearbeitung",
    "editTitle": "Verändere Details gezielt.",
    "editBody": "Dir gefällt nur das Sofa nicht? Kreise es ein und tippe, was du stattdessen möchtest. archelier verändert nur diesen Bereich und lässt den Rest des Raums unverändert – genau wie bei Wandfarbe, Teppichen, Licht und Kunst.",
    "editPrompt": "Ein Vintage-Ledersofa",
    "shopTitle": "Shoppe den Look.",
    "shopBody": "Jedes Design enthält Möbel-Liste, Farbpalette und Lichtkonzept. Jedes Stück verlinkt auf eine Suche nach ähnlichen Objekten.",
    "gioEyebrow": "Gio",
    "gioTitle": "Besprich es mit einem Designer.",
    "gioBody": "Gio ist dein KI-Raumdesigner in einem eigenen Tab. Sende ein Foto deines Raums, ein Bild oder Link eines Lieblingsraums oder ein Design. Gio schlägt eine Richtung vor und erstellt oder bearbeitet das Design direkt im Chat.",
    "gioRole": "Raumdesigner",
    "gioUser": "Das ist meine Küche mit Essbereich. Es wirkt etwas kalt. Ideen?",
    "gioReply": "Kombinieren wir warmes Holz, weiche Textilien und sanftes Licht statt kühler Flächen. Hier ist eine Idee zum Ausprobieren:",
    "gioCardTitle": "Japandi-Wärme",
    "gioCardBody": "Natürliche Eiche und strukturierter Putz bringen sofort Wärme in den Raum.",
    "gioCardAction": "Erstellen",
    "priceEyebrow": "Preise",
    "priceTitle": "Jeden Tag kostenlos. Kein Abo.",
    "price1": "Täglich kostenlose Designs, erneuert um Mitternacht",
    "price2": "Ein Bonus, wenn du ein Konto erstellst",
    "price3": "Lade Freunde ein und ihr erhaltet beide mehr",
    "price4": "Mehr nötig? Lade ein Guthaben-Paket auf",
    "privacyTitle": "Deine Fotos gehören dir.",
    "privacyBody": "Deine Fotos, Prompts und Designs werden nie zum Trainieren von KI-Modellen oder für Werbung genutzt. Deine Designs bleiben privat, außer du teilst sie.",
    "faqTitle": "Fragen",
    "faq1Q": "Was ist archelier?",
    "faq1A": "archelier (Architect + Atelier) ist eine KI-App für Inneneinrichtung für dein Smartphone und das Web. Richte deine Kamera auf einen Raum, wähle einen Stil und erhalte eine fotorealistische Neugestaltung genau dieses Raums – mit jedem Möbelstück benannt und verlinkt. Es funktioniert für Innenräume, Außenbereiche und Gärten.",
    "faq2Q": "Wie funktioniert es?",
    "faq2A": "Mache ein Foto des Raums oder lade eine Skizze, einen Grundriss oder einen 3D-Screenshot hoch. Wähle einen von 48 Stilen, beschreibe deinen eigenen oder lade ein Referenzfoto hoch. In etwa einer Minute erhältst du ein fotorealistisches Rendering deines Raums sowie eine Möbelliste, Farbpalette und einen Lichtplan.",
    "faq3Q": "Ist archelier kostenlos?",
    "faq3A": "Ja. Es gibt kein Abo. Jeder erhält täglich kostenlose Designs, erneuert um Mitternacht, plus einen Bonus für die Kontoerstellung und das Einladen von Freunden. Wenn du mehr möchtest, kannst du ein Guthaben-Paket kaufen.",
    "faq4Q": "Kann es einen Grundriss in ein 3D-Rendering verwandeln?",
    "faq4A": "Ja. Der Grundriss-Modus verwandelt einen 2D-Grundriss in eine 3D-Ansicht des gesamten Hauses im Stil deiner Wahl. Er kann auch eine Handskizze oder einen unscharfen Plan in eine saubere Zeichnung oder einen farbigen Plan umwandeln.",
    "faq5Q": "Kann ich den Stil eines Fotos übernehmen, das mir gefällt?",
    "faq5A": "Ja. Wähle den Referenzstil und lade das Inspirationsfoto hoch. archelier übernimmt Stimmung, Materialien sowie Farbpalette und wendet sie auf deinen Raum an, ohne das Layout zu kopieren.",
    "faq6Q": "Kann ich nur einen Teil eines Designs ändern?",
    "faq6A": "Ja. Kreise den Bereich ein, den du ändern möchtest – das Sofa, den Teppich, eine Wand – und gib ein, was du stattdessen möchtest. Nur dieser Bereich wird neu gestaltet; der Rest des Raums bleibt unverändert.",
    "faq7Q": "Was ist Gio?",
    "faq7A": "Gio ist der KI-Raumdesigner von archelier. Sende ihm ein Foto deines Raums, ein Bild oder einen Link eines Raums, den du liebst, oder eines deiner Designs. Gio schlägt eine Richtung vor, erstellt oder bearbeitet das Design für dich im Chat und beantwortet Fragen zu Farbe, Budget und Beleuchtung.",
    "faq8Q": "Werden meine Fotos zum Trainieren von KI verwendet?",
    "faq8A": "Nein. archelier nutzt deine Fotos, Prompts oder Designs nicht zum Trainieren von KI-Modellen oder für Werbung. Deine Designs bleiben in deinem Konto privat, außer du teilst sie.",
    "faq9Q": "Wo kann ich archelier nutzen?",
    "faq9A": "Im App Store, auf Google Play und im Web unter archelier.co. Dein Konto und deine Designs bleiben überall synchronisiert. archelier ist in 11 Sprachen verfügbar.",
    "ctaTitle": "Gestalte deinen Raum noch heute neu.",
    "ctaBody": "Auf deinem Smartphone und im Web. Deine Designs bleiben überall synchronisiert.",
    "langLabel": "Sprache"
  },
  "upgradeToPro": "Auf Pro upgraden",
  "creditsPerMonth": "{n} Credits pro Monat",
  "planFreeName": "Kostenlos",
  "planFreeTagline": "Teste archelier mit ein paar Designs im Monat.",
  "planProName": "Pro",
  "planProTagline": "Für alle, die regelmäßig hochwertige Designs erstellen.",
  "planStudioName": "Studio",
  "planStudioTagline": "Für Power-User, Teams und kommerzielle Projekte.",
  "planFeatWatermark": "Inklusive „archelier“-Wasserzeichen",
  "planFeatNoWatermark": "Kein Wasserzeichen auf gespeicherten oder geteilten Designs",
  "planFeatUnlimited": "Unbegrenzte KI-Design-Generierungen",
  "planFeatUnlimitedChat": "Unbegrenzter KI-Chat pro Design (kostenlos: 3 Runden)",
  "planFeatUnlimitedEdit": "Unbegrenzte Bereichsbearbeitungen",
  "planFeatFeed": "Im Feed teilen",
  "planFeatEverythingPro": "Alles aus Pro",
  "planFeatCommercial": "Kommerzielle Nutzungsrechte",
  "planFeatApiAccess": "API-Zugriff (demnächst)",
  "planCtaSubscribe": "Abonnieren",
  "planCtaCurrent": "Dein aktueller Tarif",
  "planPopular": "Beliebtest",
  "signInToSubscribe": "Anmelden zum Abonnieren",
  "signInToBuy": "Anmelden zum Kaufen",
  "trialNote": "{n} Tage kostenlos testen",
  "creditPacksTitle": "Oder mit Guthaben-Paketen aufladen",
  "creditPacksSubtitle": "Einmaliger Kauf, kein Abo nötig.",
  "packStarterName": "Starter-Paket",
  "packStandardName": "Standard-Paket",
  "packProName": "Pro-Paket",
  "packCreditsAmount": "{n} Credits",
  "packCtaBuy": "Kaufen",
  "pricingFootnote": "Preise in USD. Steuern werden an der Kasse berechnet. Jederzeit kündbar.",
  "errBillingGeneric": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "accountTitle": "Einstellungen",
  "accountPlanSection": "Abonnement",
  "accountCreditsSection": "Credits",
  "accountCreditsDesc": "Credits werden für das Generieren von Designs verbraucht. Jederzeit aufladbar.",
  "viewPlans": "Tarife ansehen",
  "changePlan": "Tarif ändern",
  "manageBilling": "Abrechnung verwalten",
  "manageBillingWebHint": "Wenn du das Abo im Web abgeschlossen hast, kannst du es auf archelier.co verwalten.",
  "buyCreditPack": "Guthaben-Paket kaufen",
  "subRenewsAt": "Verlängert sich am {date}",
  "subEndsAt": "Endet am {date}",
  "trialEndsAt": "Testversion endet am {date} — danach 9,99 $/Monat",
  "trialCancelEndsAt": "Testversion endet am {date} — Abo wird nicht verlängert",
  "subStatus_past_due": "Zahlung überfällig — bitte aktualisiere deine Zahlungsmethode.",
  "subStatus_canceled": "Abonnement gekündigt.",
  "subStatus_unpaid": "Abonnement unbezahlt.",
  "subStatus_trialing": "Kostenlose Testversion aktiv.",
  "account": "Konto",
  "pricing": "Preise",
  "upgrade": "Upgrade",
  "inviteTitle": "Freunde einladen & Credits verdienen",
  "inviteSubtitle": "Wenn sich jemand über deinen Link anmeldet, erhältst du +{inviter} Credits und die Person +{invitee}.",
  "inviteFriends": "Freunde einladen",
  "inviteSignInHint": "Melde dich an, um deinen persönlichen Einladungslink zu erhalten.",
  "yourReferralCode": "Dein Einladungslink",
  "inviteCodeLoading": "Einladungslink wird erstellt…",
  "inviteLinkHint": "Neue Anmeldungen über deinen Link erhalten +{n} Start-Credits.",
  "copyLink": "Link kopieren",
  "shareLink": "Link teilen",
  "inviteShareText": "Gestalte deine Räume mit KI auf archelier neu. Nutze meinen Link für +{n} kostenlose Credits.",
  "redeemTitle": "Hast du einen Code?",
  "redeemDesc": "Gib einen Einladungscode oder Aktionscode ein, um Bonus-Credits zu erhalten.",
  "copyCode": "Code kopieren",
  "errRefSelf": "Du kannst deinen eigenen Einladungscode nicht nutzen.",
  "landingInviteTitle": "Ein Freund hat dich eingeladen – ihr beide erhaltet +{n} Credits.",
  "landingInviteAutoIos": "Installiere die App, tippe dann erneut auf diesen Einladungslink – die App öffnet sich und dein Bonus wird bei der Registrierung gutgeschrieben.",
  "landingInviteAutoAndroid": "Installiere die App über den Google Play-Button unten und registriere dich – dein Bonus wird automatisch gutgeschrieben. Falls nicht, gib diesen Code unter Einstellungen → Freunde einladen ein.",
  "landingInviteDesktop": "Registriere dich hier und dein Bonus wird sofort gutgeschrieben. Um ihn in der Handy-App zu nutzen, scanne den QR-Code und folge den Schritten auf deinem Smartphone.",
  "promoTitle": "Hast du einen Promo-Code?",
  "promoDesc": "Gib einen Promo-Code ein, um Bonus-Credits einzulösen.",
  "promoPlaceholder": "z. B. LAUNCH2026",
  "promoRedeem": "Einlösen",
  "promoSuccess": "Eingelöst – {n} Credits wurden deinem Konto gutgeschrieben.",
  "errPromoInvalid": "Dieser Code ist ungültig.",
  "errPromoExpired": "Dieser Code ist abgelaufen.",
  "errPromoMaxed": "Dieser Code hat sein Nutzungslimit erreicht.",
  "errPromoUsed": "Du hast diesen Code bereits eingelöst.",
  "errPromoUserInit": "Bitte lade die Seite neu und versuche es noch einmal.",
  "errPromoGeneric": "Code konnte nicht eingelöst werden. Bitte versuche es noch einmal.",
  "reportThisDesign": "Dieses Design melden",
  "reportShort": "Melden",
  "reportTitle": "Design melden",
  "reportDesc": "Was stimmt mit diesem Design nicht? Nur Moderatoren sehen deine Meldung.",
  "reportReason_spam": "Spam oder Werbung",
  "reportReason_nsfw": "Sexuelle oder unangemessene Inhalte",
  "reportReason_copyright": "Urheberrechtsverletzung",
  "reportReason_other": "Sonstiges",
  "reportNotePlaceholder": "Details hinzufügen (optional, max. 500 Zeichen)",
  "reportSubmit": "Meldung senden",
  "reportSubmitting": "Wird gesendet…",
  "reportSignInHint": "Bitte melde dich an, um eine Meldung zu senden.",
  "reportThanks": "Meldung erhalten",
  "reportThanksDesc": "Wir schauen es uns an und handeln bei Bedarf. Danke für den Hinweis.",
  "errReportGeneric": "Meldung konnte nicht gesendet werden. Bitte versuche es gleich noch einmal.",
  "blockUser": "Diesen Nutzer blockieren",
  "unblockUser": "Entblocken",
  "blockShort": "Blockieren",
  "blockConfirm": "Blockiere @{handle}? Du wirst deren Designs oder Aktivitäten nicht mehr sehen und sie können nicht mit deinen interagieren.",
  "blockedUsersMenu": "Blockierte Nutzer",
  "blockedUsersTitle": "Blockierte Nutzer",
  "blockedUsersDesc": "Von dir blockierte Nutzer. Ihre Designs sind in deinem Feed und deinen Profilen ausgeblendet.",
  "blockedUsersEmpty": "Du hast niemanden blockiert.",
  "profileBlocked": "Du hast diesen Nutzer blockiert.",
  "profileBlockedAction": "Blockierung aufheben, um ihre Designs wieder zu sehen.",
  "errBlockGeneric": "Blockierstatus konnte nicht aktualisiert werden. Bitte versuche es noch einmal.",
  "errBlockedCustomCommand": "Deine Anfrage enthält nicht erlaubte Wörter.",
  "moderationAutoUnlisted": "Dieses Design wurde durch unsere Moderationsprüfung automatisch aus dem öffentlichen Feed entfernt. Wenn du glaubst, dass dies ein Fehler ist, kontaktiere bitte die Admins.",
  "promptLang": "German"
};
